import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class SalesOrders_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public SalesOrders: SalesOrders_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

